/**
 * Global event system for handling session expiration
 * This allows different parts of the app to trigger the session expired modal
 */

// Custom event type for session expiration
export const SESSION_EXPIRED_EVENT = 'sessionExpired';

/**
 * Trigger session expired event globally
 * This can be called from HTTP interceptors, guards, or any other part of the app
 */
export const triggerSessionExpired = (): void => {
  const event = new CustomEvent(SESSION_EXPIRED_EVENT);
  window.dispatchEvent(event);
};

/**
 * Listen for session expired events
 * @param callback - Function to call when session expires
 * @returns cleanup function to remove the event listener
 */
export const onSessionExpired = (callback: () => void): (() => void) => {
  const handleSessionExpired = () => {
    callback();
  };

  window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);

  // Return cleanup function
  return () => {
    window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
  };
};
